module.exports = "/_next/static/media/onboard-2-shift.c3bf4d87.webm";